export default __webpack_public_path__ + "static/media/Sunset-Turbines-Narrow-480px-180px.eac086c3.jpg";